<script setup lang="ts">
import Partner400FHeaderMenu from './Partner400FHeaderMenu.vue';
import { useCvButtonNavigation } from './useCvButtonNavigation';
import NuxtLinkFlat from 'theme/components/atoms/NuxtLinkFlat.vue';
import { useDeviceType } from 'theme/composables/useDeviceType';
import { ref, watch } from 'vue';

const { cvButtonTo } = useCvButtonNavigation();

withDefaults(defineProps<{ showNavigation?: boolean }>(), {
  showNavigation: true,
});

const isActive = ref(false);
const items = [
  {
    to: '#about',
    text: 'サービスについて',
  },
  {
    to: '#reviews',
    text: 'みんなの相談',
  },
  {
    to: '#steps',
    text: '利用の流れ',
  },
];

const route = useRoute();
const routeFullPath = computed(() => route.fullPath);
watch(routeFullPath, () => {
  isActive.value = false;
});
const toggleMenu = () => (isActive.value = !isActive.value);
const { isDesktop } = useDeviceType();
</script>

<template>
  <div class="header">
    <h1 class="header__logo logo">
      <a href="#header" class="logo__wrap">
        <img
          class="logo__img"
          src="~/assets/images/logo/logo_okaneko.svg"
          alt="オカネコ"
        />
      </a>
    </h1>

    <template v-if="showNavigation">
      <div class="header__toggle toggle" @click="toggleMenu">
        <img src="./menu.svg" alt="menu" class="toggle__icon" />
      </div>

      <Partner400FHeaderMenu
        :is-active="isActive"
        class="header__mobile-menu"
        @close="toggleMenu"
      />

      <nav class="header__nav nav">
        <ul class="nav__list list">
          <li v-for="item in items" :key="item.to" class="list__item item">
            <a :href="item.to" class="item__link link">{{ item.text }}</a>
          </li>
        </ul>
      </nav>

      <NuxtLinkFlat
        v-if="isDesktop"
        class="header__button"
        :to="cvButtonTo"
        variant="conversion"
        >まずは診断</NuxtLinkFlat
      >
    </template>
  </div>
</template>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 68px;
  padding: 0 16px;
  gap: 64px;

  @include desktop-only {
    height: 100px;
    padding: 0 40px;
  }

  &__logo {
    transform: translateY(1px);

    @include desktop-only {
      transform: translateY(3px);
    }
  }

  &__toggle {
    @include desktop-only {
      display: none;
    }
  }

  &__mobile-menu {
    z-index: 1;
    position: fixed;
    top: 0;
    left: 0;
  }

  &__nav {
    display: none;

    @include desktop-only {
      display: inline-block;
      flex: 1;
      margin-left: auto;
    }
  }

  &__button {
    @include desktop-only {
      border-radius: 6px;
      background: linear-gradient(94deg, #ff5e00 0%, #ffc412 100%);
      display: inline-flex;
      border: none;
    }
    padding: 7px 19px 9px 19px;
    font-size: 14px;
  }
}

.logo {
  &__wrap {
    display: flex;
    align-items: flex-start;
  }

  &__icon {
    display: inline-block;
    width: auto;
    height: 24px;
    margin: 0 4px;
    max-width: 100%;

    @include desktop-only {
      height: 32px;
      margin: 0 8px;
    }
  }

  &__img {
    height: 32px;
  }
}

.list {
  display: flex;
  gap: 48px;
  grid-template-columns: repeat(auto-fit, minmax(8em, max-content));
  align-items: center;
  justify-content: flex-end;
}

.link {
  font-size: 16px;
  font-weight: bold;
  color: $color-text-and-object-high-emphasis;
}
</style>
